import React, { useCallback } from 'react';
import { Responsive } from '@cian/ui-kit';
import { ActionAfterViewed } from '@cian/action-after-viewed-component';

import { UsefulRealtor } from '../../components/UsefulRealtor';
import { Realtors } from '../../components/Realtors';
import { HowItWorks } from '../../components/HowItWorks';
import { Faq } from '../../components/Faq';
import { Contacts } from '../../components/Contacts';
import { SearchBlockContainer } from '../SearchBlockContainer';
import { HeroMobile } from '../../components/HeroMobile';
import {
  ETrackGoToApplicationFormLabel,
  trackGoToAllRealtors,
  trackGoToApplicationForm,
  trackPodborIntoView,
  trackContactIntoView,
  trackFAQIntoView,
  trackHowItWorksIntoView,
  trackSearchIntoView,
  trackMainIntoView,
  trackRealtorBenefitsIntoView,
} from './tracking';
import { HelpSearchRealtorContainer } from '../HelpSearchRealtorContainer';
import { useSmartContactPixel } from './utils/useSmartContactPixel';

export const PageContainer: React.FC = () => {
  const onClickGoToAppFormPodbor = useCallback(
    () => trackGoToApplicationForm(ETrackGoToApplicationFormLabel.Podbor),
    [],
  );
  const onClickGoToAppFormContact = useCallback(
    () => trackGoToApplicationForm(ETrackGoToApplicationFormLabel.Contact),
    [],
  );
  useSmartContactPixel();

  return (
    <div>
      <Responsive desktop>
        <ActionAfterViewed callback={trackSearchIntoView}>
          <SearchBlockContainer />
        </ActionAfterViewed>
      </Responsive>
      <Responsive tablet phone>
        <HeroMobile />
      </Responsive>
      <ActionAfterViewed callback={trackMainIntoView}>
        <HelpSearchRealtorContainer />
      </ActionAfterViewed>
      <ActionAfterViewed callback={trackRealtorBenefitsIntoView}>
        <UsefulRealtor />
      </ActionAfterViewed>
      <ActionAfterViewed callback={trackContactIntoView}>
        <Realtors onClickGoToAllRealtors={trackGoToAllRealtors} onClickGoToApplicationForm={onClickGoToAppFormPodbor} />
      </ActionAfterViewed>
      <ActionAfterViewed callback={trackHowItWorksIntoView}>
        <HowItWorks />
      </ActionAfterViewed>
      <ActionAfterViewed callback={trackFAQIntoView}>
        <Faq />
      </ActionAfterViewed>
      <ActionAfterViewed callback={trackPodborIntoView}>
        <Contacts onClickGoToApplicationForm={onClickGoToAppFormContact} />
      </ActionAfterViewed>
    </div>
  );
};

PageContainer.displayName = 'PageContainer';
